import React from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import resBlack from "./../../assets/icons/subscription.png";
import productBlack from "./../../assets/icons/product (1).png";
import empBlack from "./../../assets/icons/wholesaler.png";
import vat from "./../../assets/icons/discount.png";
import Leo from "./../../assets/images/Leo.png";
import designaition from "./../../assets/icons/recommend.png";
import servicecharge from "./../../assets/icons/customer-service.png";
import DatatableComponent from "../components/DatatableComponent.tsx";
import CustomDataGrid from "../components/CustomDataGrid/CustomDataGrid.tsx";
import { useNavigate } from "react-router-dom";
import FilterComponents from "../product/components/FilterComponents.tsx";
import RestaurantSetupPage from "./components/RestaurantSetupPage/RestaurantSetupPage.tsx";
import VATSetupPage from "./components/VATSetupPage/VATSetupPage.tsx";
import SideBar from "../layouts/sidebar/SideBar.tsx";
import EmployeeSetupPage from "./components/EmployeeSetupPage/EmployeeSetupPage.tsx";
import ServiceChargeSetupPage from "./components/ServiceChargeSetupPage/ServiceChargeSetupPage.tsx";
import AddDiscountOfferToHomePage from "./AddDiscountOfferToHomePage/AddDiscountOfferToHomePage.tsx";
import AddSubscriptinOfferToHomePage from "./AddSubscriptinOfferToHomePage/AddSubscriptinOfferToHomePage.tsx";
import AddWholesellSetup from "./AddWholesellSetup/AddWholesellSetup.tsx";
import AddRecommendedItemForHomePage from "./AddRecommendedItemForHomePage/AddRecommendedItemForHomePage.tsx";
import Tag from "./../../assets/icons/tag.png";
import AddTagsForHomePage from "./AddTagsForHomePage/AddTagsForHomePage.tsx";
import jwt_decode from "jwt-decode";
import FoodCategory from "./AddFoodcategory/FoodCategory.tsx";

function SettingsForAdmin(props) {
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [open, setOpen] = React.useState(false);

  const toggleDrawer =
    (anchor: Anchor) => (event: React.KeyboardEvent | React.MouseEvent) => {
      console.log(
        "(event as React.KeyboardEvent).key: " +
          (event as React.KeyboardEvent).key
      );
      console.log("event: " + event);
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState((prevState) => ({
        ...prevState,
        [anchor]: !prevState[anchor],
      }));
    };
  const clickMenuList = (props) => {
    console.log("props: " + props);
    if (props === "Manage restaurant") {
      navigate("/restaurant-setup");
    } else if (props === "Manage Product") {
      navigate("/manage-product");
    }
  };

  const list = (anchor: Anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        marginTop: 5,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["Manage restaurant", "Manage Employee", "Manage Product"].map(
          (text, index) => (
            <ListItem
              key={text}
              disablePadding
              onClick={() => clickMenuList(text)}
            >
              <ListItemButton>
                <ListItemIcon>
                  {index === 0 ? (
                    <img src={resBlack} style={{ width: "1.5rem" }} />
                  ) : index === 1 ? (
                    <img src={empBlack} style={{ width: "1.5rem" }} />
                  ) : (
                    <img src={productBlack} style={{ width: "1.5rem" }} />
                  )}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
    </Box>
  );
  const [menuSelection, setMenuSelection] = React.useState(0);
  const changeMenu = (props) => {
    setMenuSelection(props);
  };
  const [tokenData, setTokenData] = React.useState({
    UserName: "",
  });
  React.useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }
  }, []);
  return (
    <div>
      <div
        className=" d-flex justify-content-between"
        style={{ height: "3.5rem", backgroundColor: "#56595b" }}
      >
        <div className="">
          <div className="d-flex flex-row">
            <div>
              <SideBar />
            </div>
            <h4 className="mt-1" style={{ color: "white", marginLeft: "1rem" }}>
              Go{" "}
              <span style={{ color: "#e5e5e5", fontWeight: "700" }}>Taste</span>
            </h4>
          </div>
        </div>
        <div
          className="d-flex"
          style={{ marginRight: "1rem", marginTop: "10px", gap: "10px" }}
        >
          <h5 style={{ color: "white", marginRight: "1rem" }}>
            Welcome, {tokenData.UserName}
          </h5>
          {/* {
                        tokenData.UserImg != undefined ? (
                            <img src={tokenData.UserImg} alt='leo' style={{ width: '2rem', height: '2rem' }} />
                        ) : <img src={userImg} alt='leo' style={{ width: '2rem', height: '2rem' }} />

                    } */}

          <h5
            style={{ color: "white", marginRight: "1rem", cursor: "pointer" }}
            onClick={() => {
              localStorage.removeItem("gotasteadmintoken");
              localStorage.removeItem("permissions");
              window.location.href = `/`;
            }}
          >
            Log Out
          </h5>
        </div>
      </div>
      <div className="d-flex" style={{ overflow: "hidden" }}>
        <div className="d-flex" style={{ width: "107vw" }}>
          <div className="">
            <div
              className="scrollable-div"
              style={{ width: "13rem", height: "100vh" }}
            >
              <div
                className={`menuItem ${menuSelection == 0 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(0)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Add Subscription Offers
                  </p>
                </div>
              </div>
              <div
                className={`menuItem ${menuSelection == 1 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(1)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={vat}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Add Discount offers
                  </p>
                </div>
              </div>

              <div
                className={`menuItem ${menuSelection == 3 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(3)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={empBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Wholesell Setup
                  </p>
                </div>
              </div>
              <div
                className={`menuItem ${menuSelection == 4 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(4)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={designaition}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Add Recommended Item
                  </p>
                </div>
              </div>
              <div
                className={`menuItem ${menuSelection == 5 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(5)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={Tag}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Add Tags
                  </p>
                </div>
              </div>

              <div
                className={`menuItem ${menuSelection == 6 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(6)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={Tag}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Add Food Category
                  </p>
                </div>
              </div>
            </div>
          </div>
          {menuSelection === 0 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <AddSubscriptinOfferToHomePage />
            </div>
          ) : menuSelection === 1 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <AddDiscountOfferToHomePage />
            </div>
          ) : menuSelection === 3 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <AddWholesellSetup />
            </div>
          ) : menuSelection == 4 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <AddRecommendedItemForHomePage />
            </div>
          ) : menuSelection == 5 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <AddTagsForHomePage />
            </div>
          ) : menuSelection == 6 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <FoodCategory />
            </div>
          ) : (
            <p>Coming soon</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SettingsForAdmin;
